import { login } from "@ui/Auth/api";
import {
  createRecordWithHook,
  getByCode,
  getPaginatedData,
  search,
} from "@ui/ComponentUtils/blueprintAPIs";
import { regexPurify, uniqueArray } from "@ui/Utils/helper";
import HTTP from "@ui/Utils/http";
import commonConfig from "config/commonConfig";
import enums from "config/enums";
import { isEmpty, uniqBy } from "lodash";
import { getClientDetails } from "utils/common/common.utils";
import localStorageUtils, {
  localStorageKeys,
} from "utils/local-utils/localstorage.utils";

const mainClient = getClientDetails(commonConfig.clients);
console.log("mainClient", mainClient);

const baseUrl = commonConfig.baseApiUrl;
export const eCreativeLogin = async () => {
  const response = await login;
};

export const getOverview = async () => {
  const response = await search(
    enums.models.overviews,
    {
      client: mainClient.id,
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;

  //   const requestHeaders = {
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //   };
  //   const response = await axios.post(
  //     `${baseUrl}${enums.models.overviews}/search`,
  //     {
  //       client: mainClient.id,
  //     },
  //     {
  //       headers: {
  //         Authorization: JSON.stringify(
  //           localStorageUtils?.get(localStorageKeys?.token)
  //         ),
  //         Division: JSON.stringify(
  //           localStorageUtils?.get(localStorageKeys?.division)
  //         ),
  //         Isdivisioncontrolled: mainClient?.isDivisionControlled,
  //       },
  //     }
  //   );
};

export const getDivisionByClientId = async () => {
  const response = await search(
    enums.models.divisions,
    {
      client: mainClient?.id,
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;
};

export const getAllCategories = async () => {
  const response = await search(
    enums.models.category,
    {
      client: mainClient.id,
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;
};

export const getClientProducts = async () => {
  const response = await search(
    enums.models.products,
    {
      client: mainClient.id,
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;
};

export const getProductByCode = async (code) => {
  const response = await getByCode(enums.models.products, code);

  return response;
};

export const getOrders = async (createById, sortMethod) => {
  const response = await search(
    enums.models.orders,
    {
      client: mainClient.id,
      sort: sortMethod,
      "createdBy._id": createById,
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;
};

export const searchProducts = async (
  searchText,
  pageNo = 0,
  perPageRecords,
  category_id,
  sort
) => {
  const response = await getPaginatedData(
    enums.models.products,
    {
      criteria: [
        {
          $or: [
            { styleNo: { $regex: regexPurify(searchText), $options: "i" } },
            { sku: { $regex: regexPurify(searchText), $options: "i" } },
            // { netWeight: { $regex: regexPurify(searchText), $options: "i" } },
            // { grossWeight: { $regex: regexPurify(searchText), $options: "i" } },
            {
              "category.name": {
                $regex: regexPurify(searchText),
                $options: "i",
              },
            },
          ],
        },
        isEmpty(category_id)
          ? {}
          : {
              "category._id": category_id,
            },
        {},
      ],
      client: mainClient.id,
      pageSize: perPageRecords,
      page: pageNo,
      sort: sort,
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;
};

export const getClientProductsPaging = async (
  pageNo,
  perPageRecords,
  category_id,
  sort
) => {
  const response = await getPaginatedData(
    enums.models.products,
    {
      criteria: [
        isEmpty(category_id)
          ? {}
          : {
              "category._id": category_id,
            },
        {},
      ],
      client: mainClient.id,
      pageSize: perPageRecords,
      page: pageNo,
      sort: sort,
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;
};

// export const getCartItems = async () => {
//   const user = localStorageUtils.get(localStorageKeys.userDetails);

//   let uniqueCart = await searchWithoutLoading(enums.models.carts, {
//     "createdBy._id": user?.id,
//   });

//   uniqueCart = uniqueCart[0] || {};

//   if (uniqueCart?.code) {
//     uniqueCart.items = [...(uniqueCart.items || []), ...(items || [])];
//     uniqueCart.items = uniqueArray(uniqueCart.items);

//     uniqueCart = await updateRecordWithoutLoading(enums.models.carts, {
//       items: uniqueCart.items,
//       code: uniqueCart.code,
//       populate: "items.product",
//     });

//     return uniqueCart;
//   }

//   return response;
// };

export const createRecordWithoutLoading = async (model, data) => {
  try {
    const res = await HTTP.post(baseUrl + model, data);

    return res?.data?.data;
  } catch (err) {
    console.log(err?.response?.data);
    throw err;
  }
};

export const updateRecordWithoutLoading = async (model, data) => {
  try {
    const res = await HTTP.put(baseUrl + model + "/" + data?.code, data);

    return res?.data?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const searchWithoutLoading = async (
  model,
  criteria = {},
  { unAuth } = {}
) => {
  try {
    let url = baseUrl + model + "/search";
    // if (unAuth) {
    //   url += "/unAuth"; // HANDLE THIS ASAP when required,
    // for now || req.headers.auth is given for api\src\@middlewares\authentication.js
    // }
    console.log(url);
    const res = await HTTP.post(url, criteria);

    return res?.data?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const unifyGlobalCart = async (items = []) => {
  try {
    const user = localStorageUtils.get(localStorageKeys.userDetails) || {};

    let uniqueCart =
      (await searchWithoutLoading(enums.models.carts, {
        "createdBy._id": user?._id,
        populate: [
          {
            path: "items.product",
            db: "data-engine",
            collection: "products",
          },
        ],
      })) || [];

    uniqueCart = uniqueCart[0] || {};

    if (uniqueCart?.code) {
      uniqueCart.items = [...(uniqueCart.items || []), ...(items || [])];
      uniqueCart.items = uniqueArray(uniqueCart.items);

      uniqueCart = await updateRecordWithoutLoading(enums.models.carts, {
        items: uniqueCart.items,
        code: uniqueCart.code,
      });

      return uniqueCart;
    }

    return {};
  } catch (err) {
    console.log(err);
    return items || [];
  }
};

export const setCartItems = async (value) => {
  let cartItems = value;
  let unifyCart = [];
  if (!cartItems) {
    cartItems = localStorageUtils.get(localStorageKeys.cartItems);

    // cartItems = await unifyGlobalCart(cartItems?.items || []);
  }

  //   await updateRecord(enums.models.carts, cartItems);

  localStorageUtils.set(localStorageKeys.cartItems, cartItems);
};

export const setWishListItems = (value) => {
  let wishListItems = value;
  if (!wishListItems) {
    wishListItems = localStorageUtils.get(localStorageKeys.wishListItems);
  }

  localStorageUtils.set(localStorageKeys.wishListItems, wishListItems);
};

export const addToCart = async (
  cartParameter,
  inputFields = { quantity: 1 }
) => {
  // this.logic definition:
  // Products: A, B, C, D
  // We can add product A as 2 different cart items
  // A - color: red, size: 4, quantity: 4
  // A - color: blue, size: 10, quantity: 10
  try {
    const user = localStorageUtils.get(localStorageKeys.userDetails) || {};

    if (!user?._id) {
      // Reject if user is not logged in
      return "Login to continue";
    }

    let cartItemsObj = localStorageUtils.get(localStorageKeys.cartItems) || {};
    const userCart = { ...cartItemsObj };
    let items = userCart?.items || [];

    cartParameter = Array.isArray(cartParameter)
      ? cartParameter
      : [cartParameter];

    cartParameter.forEach((product) => {
      const existingItem = items.find((item) => {
        const inputKeys = Object.keys(inputFields);

        const isSameItem =
          item &&
          product &&
          item?.product?._id === product?._id &&
          inputKeys.every(
            (key) =>
              key === "quantity" ||
              key === "remarks" ||
              inputFields[key] === item[key] // Checking for the same item, excluding quantity and remarks
          );

        return isSameItem;
      });

      if (existingItem) {
        // If the same item already exists, increase the quantity
        existingItem.quantity += inputFields?.quantity || 1;
        return;
      }

      // If it's a new item, add it to the cart
      items.push({ product, ...inputFields });
    });

    let res;
    try {
      if (userCart?.code) {
        // Update the existing cart
        res = await updateRecordWithoutLoading(enums.models.carts, {
          ...userCart,
          items,
        });
      } else {
        console.log("CREATE");
        // Create a new cart
        res = await createRecordWithoutLoading(enums.models.carts, {
          ...userCart,
          items,
        });
      }

      setCartItems(res || {});
      return res;
    } catch (err) {
      console.log(err);
      console.log(err, "Setting Carts Offline ");

      // Handle the error when updating or creating the cart
      setCartItems({ ...userCart, items } || {});
      throw err;
    }
  } catch (err) {
    // Rethrow the error to be caught by the caller
    throw err;
  }
};

export const searchUserCart = async (userId) => {
  try {
    let res = await search(enums.models.carts, {
      "createdBy._id": userId,
      populate: [
        {
          path: "items.product",
          db: "data-engine",
          collection: "products",
        },
      ],
    });

    res = res && res[0];

    setCartItems(res);

    return res;
  } catch (err) {
    console.log(err);
  }
};

export const handleCompleteOrder = async (items, overallRemarks) => {
  const response = await createRecordWithHook(
    enums.models.orders,
    {
      items,
      client: mainClient.id,
      overallRemarks,
    },
    {
      isDivisionControlled: mainClient?.isDivisionControlled,
    }
  );

  return response;
};

export const addToWishList = async (wishListParameter, isAdding) => {
  try {
    const user = localStorageUtils.get(localStorageKeys.userDetails) || {};

    if (!user?._id) {
      // Reject if user is not logged in
      return "Login to continue";
    }

    let wishListObj =
      localStorageUtils.get(localStorageKeys.wishListItems) || {};
    const wishListItems = { ...wishListObj };
    let items = wishListItems?.items || [];

    wishListParameter = Array.isArray(wishListParameter)
      ? wishListParameter
      : [wishListParameter];

    wishListParameter.forEach((product) => {
      // If it's a new item, add it to the wishlist
      if (isAdding) {
        items.push({ product });
      } else {
        const index = items.findIndex(
          (wishListItem) =>
            wishListItem?.product?._id === wishListParameter[0]?._id
        );

        if (index !== -1) {
          items.splice(index, 1);
        }
      }
    });

    items = uniqBy(items, "product._id");
    let res;
    try {
      if (wishListItems?.code) {
        // Update the existing wishList
        res = await updateRecordWithoutLoading(enums.models.wishLists, {
          ...wishListItems,
          items,
        });
      } else {
        // add new wishlist
        res = await createRecordWithoutLoading(enums.models.wishLists, {
          ...wishListItems,
          items,
        });
      }

      setWishListItems(res || {});
      return res;
    } catch (err) {
      console.log(err);
      setWishListItems({ ...wishListItems, items } || {});
      throw err;
    }
  } catch (err) {
    // Rethrow the error to be caught by the caller
    throw err;
  }
};

export const getWishList = async (createById, sortMethod) => {
  const response = await search(
    enums.models.wishLists,
    {
      client: mainClient?.id,
      "createdBy._id": createById,
      populate: [
        {
          path: "items.product",
          db: "data-engine",
          collection: "products",
        },
      ],
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;
};

export const getSpecialProducts = async () => {
  const response = await search(
    enums.models.groups,
    {
      client: mainClient?.id,
      populate: [
        {
          path: "products",
          db: "data-engine",
          collection: "products",
        },
      ],
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;
};

export const setPushNotifications = async () => {
  const response = await search(
    enums.models.alerts,
    {
      client: mainClient?.id,
    },
    { isDivisionControlled: mainClient?.isDivisionControlled }
  );

  return response;
};
